import { z } from 'zod';

export const TransactionParamSchema = z.object({
  idTransaction: z.string().min(1, 'El ID de la transacción es requerido'),
});

export const CertificateDetailSchema = z.object({
  id_request_certificate: z.string().optional(),
  id_request: z.string().optional(),
  id_product: z.coerce.number().optional(),
  id_office: z.coerce.number().optional(),
  number: z.string(),
  id_state: z.coerce.number().optional(),
  pin: z.string().nullable().optional(),
  fullname: z.string().nullable().optional(),
  document: z.string().nullable().optional(),
  observation: z.string().nullable().optional(),
  pre_consultation: z.coerce.number().nullable().optional(),
  office: z.object({
    id_office: z.coerce.number().optional(),
    description: z.string().optional(),
    value: z.string().optional(),
  }).passthrough().optional(),
  certificate: z.object({
    id_product: z.coerce.number().optional(),
    description: z.string().optional(),
    value: z.coerce.number().optional(),
  }).passthrough().optional(),
}).passthrough();

export const TransactionDetailSchema = z.object({
  id_request: z.string(),
  id_pay_status: z.coerce.number(),
  id_state: z.coerce.number().optional(),
  id_payment_method: z.string(),
  amount: z.coerce.number(),
  email: z.string(),
  phone: z.string().nullable().optional(),
  fullname: z.string().nullable().optional(),
  address: z.string().nullable().optional(),
  document: z.string().nullable().optional(),
  type_doc: z.union([z.string(), z.number()]).nullable().optional(),
  created_at: z.union([z.string(), z.date()]),
  updated_at: z.union([z.string(), z.date()]).nullable().optional(),
  pay_id: z.union([z.string(), z.number()]).nullable().optional(),
  redeem_code_used: z.string().nullable().optional(),
  certificates: z.array(CertificateDetailSchema).optional(),
}).passthrough();

export const TransactionInfoResponseSchema = z.object({
  ok: z.boolean(),
  request: TransactionDetailSchema,
});

export const SendReceiptQuerySchema = z.object({
  action: z.enum(['download', 'email', 'stream']),
});

export const ReceiptDownloadResponseSchema = z.object({
  status: z.number(),
  message: z.string().optional(),
  data: z.object({
    base64: z.string(),
    nameFile: z.string(),
  }),
});

export const ReceiptEmailResponseSchema = z.object({
  status: z.number(),
  message: z.string(),
});

export const PixQueueCertificateSchema = z.object({
  number: z.string(),
  URL: z.string().optional(),
  pinCertificateRC: z.string().optional(),
  isVoucherSuccess: z.boolean().optional(),
  voucherCode: z.string().optional(),
}).passthrough();

export const PixQueueItemResponseSchema = z.object({
  status: z.enum(['COMPLETED', 'FAILED', 'PENDING_TIMEOUT', 'PENDING']),
  message: z.string().optional(),
  data: z.union([
    z.object({
      request: z.any().optional(),
      certificates: z.array(PixQueueCertificateSchema).optional(),
    }),
    z.null(),
  ]).optional(),
}).passthrough();

export type TransactionParam = z.infer<typeof TransactionParamSchema>;
export type CertificateDetail = z.infer<typeof CertificateDetailSchema>;
export type TransactionDetail = z.infer<typeof TransactionDetailSchema>;
export type TransactionInfoResponse = z.infer<typeof TransactionInfoResponseSchema>;
export type SendReceiptQuery = z.infer<typeof SendReceiptQuerySchema>;
export type ReceiptDownloadResponse = z.infer<typeof ReceiptDownloadResponseSchema>;
export type ReceiptEmailResponse = z.infer<typeof ReceiptEmailResponseSchema>;
export type PixQueueCertificate = z.infer<typeof PixQueueCertificateSchema>;
export type PixQueueItemResponse = z.infer<typeof PixQueueItemResponseSchema>;
